import { FC, useContext } from 'react'
import { Container, Text, ImageWrapper, RecommendedFor, CustomLink, ImagePlaceholder } from './styles'
import { BodyMedium } from '../styles'
import { Box, Image } from '@hermes/web-components'
import getDomainName from '../../../utils/getDomainName'
import { AppDataContext } from '../../../providers/AppData'
import { purifyTenantDomain } from '../../../utils/url'
import { preloadImageLoader } from '../../../utils/imageLoaders'
import getConfigVariable from '../../../utils/getConfigVariable'
import useTranslateMessage from '../../../hooks/useTranslateMessage'

interface Props {
  avatar: string | null
  name: string
  recommender: { name: string; initials: string; avatar: string }
  recommendedFor: string | null
  specialty: string
  slug: string | null
  recommenderSlug: string | null
}

const PeerEndorsementsCard: FC<Props> = ({
  avatar,
  name,
  recommendedFor,
  specialty,
  recommender,
  slug,
  recommenderSlug
}) => {
  const { locale } = useContext(AppDataContext)
  const domainName = getDomainName()
  const translate = useTranslateMessage()
  const originWithLang = purifyTenantDomain(domainName, locale)
  const host = getConfigVariable('HOST')

  return (
    <Container>
      <ImageWrapper>
        <CustomLink href={`${originWithLang}/specialist/${slug}`}>
          <Image src={preloadImageLoader({ src: avatar || '', host })} alt="avatar" width={33} height={33} />
        </CustomLink>
      </ImageWrapper>
      <Box display="flex" flexDirection="column" gap="4px">
        <CustomLink href={`${originWithLang}/specialist/${slug}`}>
          <BodyMedium
            sx={{
              fontWeight: 500,
              color: '#11245A',
              mt: '12px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '100%'
            }}
          >
            {name}
          </BodyMedium>
        </CustomLink>

        <Text>{specialty}</Text>
        <Text>{translate('homepage.endorsement.card.recommended-by')}</Text>
        <CustomLink href={`${originWithLang}/specialist/${recommenderSlug}`}>
          <Box display="flex" alignItems="center" gap="4px">
            {recommender?.avatar ? (
              <Image
                lazy
                src={preloadImageLoader({ src: recommender?.avatar, host })}
                alt="Recommender avatar"
                width={20}
                style={{ borderRadius: '50%' }}
                height={20}
              />
            ) : (
              <ImagePlaceholder style={{ width: '20px', height: '20px', fontSize: '8px' }}>
                {recommender.initials}
              </ImagePlaceholder>
            )}
            <Text
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {recommender?.name} {translate('homepage.endorsement.card.for')}
            </Text>
          </Box>
        </CustomLink>
      </Box>
      <RecommendedFor style={{ marginTop: '12px' }}>{recommendedFor}</RecommendedFor>
    </Container>
  )
}

export default PeerEndorsementsCard
